module.exports = __webpack_public_path__ + "fonts/SFUIText-Bold.0f991f59.woff";